import { render, staticRenderFns } from "./OrderDocumentsUpload.vue?vue&type=template&id=56895d1a&scoped=true&"
import script from "./OrderDocumentsUpload.vue?vue&type=script&lang=js&"
export * from "./OrderDocumentsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56895d1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VFileInput,VSelect})
